import { Box } from "@mui/material";
import styled from "styled-components";


export const ModalTitle = styled.p`
    margin:0px;
    font-size: 1.2rem;
    letter-spacing: 0px;
    line-height: 1.33333;
    font-family: 'Noto Sans', sans-serif;
    font-weight: 500;
    margin-bottom:30px;
    `

export const FormGroup = styled(Box)`width:100%;display:flex;flex-direction:column; margin-bottom:10px; flex:1`;
export const ValueField = styled.div`margin-bottom:10px;margin-top:5px;`;
export const Label = styled.label`font-size:12px; padding-left:2px; color:#474747`;

export const InputField = styled.input`background-color:#F3F3F3;border:1px solid #dad8d8;padding:10px 15px;border-radius:8px;margin-bottom:0px;margin-top:5px;
&:focus {
outline:none;
border:1px solid #bcc4e1;
}`;
export const TextArea = styled.textarea`background-color:#F3F3F3;border:1px solid #dad8d8;padding:10px 15px;border-radius:8px;margin-bottom:10px;margin-top:5px; resize:vertical; 
&:focus {
outline:none;
border:1px solid #bcc4e1;
}`;
export const Button = styled.button`
  padding: 10px 15px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #dad8d8;
  box-shadow: 1px 5px 2px 0px rgb(120 120 120 / 12%);
  background-color: black;
  color: white;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s, opacity 0.3s;

  &:disabled {
    background-color: grey;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const DangerButton = styled(Button)`
  background-color: #d32f2f;
  
  &:hover {
    background-color: #b71c1c;
  }
  
  &:disabled {
    background-color: #e57373;
  }
`;

export const Select = styled.select`
    background-color: #F3F3F3;
    border: 1px solid #dad8d8;
    padding: 10px 15px;
    border-radius: 8px;
    margin-bottom: 10px;
    margin-top: 5px;
    padding-right: calc(15px + 20px);
    background-image: url('https://www.svgrepo.com/show/80156/down-arrow.svg');
    background-position: calc(100% - 16px);
    -webkit-appearance: none;
    background-repeat: no-repeat;
    background-size: 10px 10px;
`;

export const ModalButton = styled.button`padding:20px;width:100%;border-radius:8px;border:none;box-shadow:1px 5px 2px 0px rgb(120 120 120 / 12%); background-color:black; color:white;cursor:pointer; margin-top:20px`

export const IconContainer = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  svg {
    fill: ${({ $isActive }) => ($isActive ? '#3a5bd8' : '#7E818B')};
  }
`;

export const CreateButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !['outline', 'plain'].includes(prop),
})<{ outline?: boolean; plain?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ outline, plain }) =>
    plain ? 'transparent' : outline ? 'transparent' : '#3a5bd9'};
  border: ${({ outline, plain }) =>
    plain ? 'none' : outline ? '2px solid #3a5bd9' : 'none'};
  border-radius: 3px;
  color: ${({ outline, plain }) =>
    plain ? '#3a5bd9' : outline ? '#3a5bd9' : 'white'};
  padding: ${({ outline, plain }) =>
    plain ? '8px 18px' : outline ? '6px 18px' : '8px 18px'};
  padding-right: 22px;
  padding-left: ${({ outline, plain }) =>
    plain ? '0px' : outline ? '18px' : '18px'};
  font-size: 14px;
  transition: 250ms;
  cursor: pointer;

  span {
    margin-left: ${({ outline, plain }) =>
    plain ? '5px' : outline ? '10px' : '10px'}
  }

  svg {
    fill: ${({ outline, plain }) =>
    plain ? '#3a5bd9' : outline ? '#3a5bd9' : 'white'};
  }

  &:hover {
    background-color: ${({ outline, plain }) =>
    plain ? 'transparent' : outline ? '#f0f4ff' : '#2545bf'};
    color: ${({ outline, plain }) =>
    plain ? '#2545bf' : outline ? '#2545bf' : 'white'};

    svg {
      fill: ${({ outline, plain }) =>
    plain ? '#2545bf' : outline ? '#2545bf' : 'white'};
    }
  }
`;